module.exports = __webpack_public_path__ + "static/media/female.387c9190.gif";